export const sharedColors: Record<string, string> = {
  medGray: '#657786',
  black: '#0f1419',
  blue: '#55acee',
}
